import {
  SubstationType,
  UTP2CustomQuestionTypes,
  UTP2Groups,
  UTP2Job,
  UTP2Substations,
  UTP2Switchgear,
} from "../../shared/enums/UTP2";
import type { WorkflowV1 } from "../../shared/interfaces/WorkflowV1";
import type { WorkflowV2 } from "../../shared/interfaces/WorkflowV2";
import { createWorkflowMetadataField } from "./metadata";

const emptyWorkflowDetailBase = {
  substation_id: undefined,
  switchgear_id: undefined,
  assets: [],
  survey_metadata_groups: [
    {
      name: UTP2Groups.Job,
      fields: [
        createWorkflowMetadataField(UTP2Job.JobNo, UTP2CustomQuestionTypes.TextInput, ""),
        createWorkflowMetadataField(UTP2Job.EngineerName, UTP2CustomQuestionTypes.TextInput, ""),
      ],
    },
    {
      name: UTP2Groups.Substation,
      fields: [
        createWorkflowMetadataField(UTP2Substations.SubstationName, UTP2CustomQuestionTypes.TextInput, ""),
        createWorkflowMetadataField(
          UTP2Substations.SubstationType,
          UTP2CustomQuestionTypes.Native,
          SubstationType.Indoor,
        ),
        createWorkflowMetadataField(UTP2Substations.CableNaming, UTP2CustomQuestionTypes.Native, "$L1_L2_L3"),
      ],
    },
    {
      name: UTP2Groups.Switchgear,
      fields: [
        createWorkflowMetadataField(UTP2Switchgear.Manufacturer, UTP2CustomQuestionTypes.Native, ""),
        createWorkflowMetadataField(UTP2Switchgear.Type, UTP2CustomQuestionTypes.Native, ""),
        createWorkflowMetadataField(UTP2Switchgear.InstallDate, UTP2CustomQuestionTypes.Date, ""),
        createWorkflowMetadataField(UTP2Switchgear.RatedVoltage, UTP2CustomQuestionTypes.Native, ""),
        createWorkflowMetadataField(UTP2Switchgear.OperatingVoltage, UTP2CustomQuestionTypes.Native, ""),
        createWorkflowMetadataField(UTP2Switchgear.BusbarInsulation, UTP2CustomQuestionTypes.Native, ""),
      ],
    },
  ],
};

export const emptyWorkflowV1: Partial<WorkflowV1> = {
  description: "",
  longDescription: "",
  workflowDetail: {
    ...emptyWorkflowDetailBase,
    version: 1,
  },
};

export const emptyWorkflowV2: Partial<WorkflowV2> = {
  description: "",
  longDescription: "",
  workflowDetail: {
    ...emptyWorkflowDetailBase,
    version: 2,
    asset_types: [],
  },
};
